import axios from 'axios';

const apiUrls = {
  'sao-paulo': process.env.REACT_APP_API_URL_SP,
  'belo-horizonte': process.env.REACT_APP_API_URL_BH
};

const apiTokens = {
  'sao-paulo': process.env.REACT_APP_API_TOKEN_SP,
  'belo-horizonte': process.env.REACT_APP_API_TOKEN_BH
};

const getInitialCity = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const activePage = window.sessionStorage.getItem('cidadeAtivaPage');
    if (activePage) {
      if (activePage.includes('belo-horizonte')) return 'belo-horizonte';
      if (activePage.includes('sao-paulo')) return 'sao-paulo';
    }
  }
  return 'sao-paulo';
};

const initialCity = getInitialCity();

const instance = axios.create({
  baseURL:
    apiUrls[initialCity] ||
    apiUrls['sao-paulo'] ||
    process.env.REACT_APP_API_URL_SP,
  headers: {
    Accept: 'application/json'
  }
});

let activeToken =
  apiTokens[initialCity] ||
  apiTokens['sao-paulo'] ||
  process.env.REACT_APP_API_TOKEN_SP;

instance.interceptors.request.use(
  (config) => {
    const auth = config.headers.Authorization;
    if (!auth || auth === 'Bearer undefined' || auth === 'Bearer ') {
      if (activeToken) {
        config.headers.Authorization = `Bearer ${activeToken}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const setApiCity = (citySlug) => {
  const url = apiUrls[citySlug];
  if (url) {
    instance.defaults.baseURL = url;
  }
  const token = apiTokens[citySlug];
  if (token) {
    activeToken = token;
  }
};

export const getApiUrl = (citySlug) => {
  return (
    apiUrls[citySlug] ||
    apiUrls['sao-paulo'] ||
    process.env.REACT_APP_API_URL_SP
  );
};

export const getApiToken = (citySlug) => {
  return (
    apiTokens[citySlug] ||
    apiTokens['sao-paulo'] ||
    process.env.REACT_APP_API_TOKEN_SP
  );
};

export default instance;
